/**
 * ブランドマスタ（デフォルト値）
 * Firestoreのデータで上書き可能
 * ソース: mall DB production 直近1年実績（2026-03-31時点）
 *
 * @graph-stack mall-api
 * @graph-domain Operations
 * @graph-business モール取扱ブランドの表示名・フォールバック転換率マスタ。47ブランド
 * @graph-connects none
 */
export const DEFAULT_BRANDS = {
    // レンタル数順
    パナソニック: { label: 'パナソニック(Panasonic)', fallbackRate: 19.5 },
    リファ: { label: 'リファ(ReFa)', fallbackRate: 26.6 },
    ヤーマン: { label: 'ヤーマン(YA-MAN)', fallbackRate: 10.5 },
    SIXPAD: { label: 'シックスパッド(SIXPAD)', fallbackRate: 12.3 },
    西川: { label: 'nishikawa(西川)', fallbackRate: 18.5 },
    キヌージョ: { label: 'キヌージョ(KINUJO)', fallbackRate: 21.2 },
    マイトレックス: { label: 'マイトレックス(MYTREX)', fallbackRate: 17.2 },
    ベレガ: { label: 'ベレガ(BELEGA)', fallbackRate: 12.5 },
    ブライト: { label: 'ブライト(Brighte)', fallbackRate: 8.1 },
    ミラブル: { label: 'ミラブル(Mirable)', fallbackRate: 18.1 },
    エレクトロン: { label: 'エレクトロン(ELECTRON)', fallbackRate: 5.5 },
    カドー: { label: 'カドー(cado)', fallbackRate: 15.3 },
    ステラボーテ: { label: 'ステラボーテ(STELLA BEAUTE)', fallbackRate: 14.5 },
    ブレインスリープ: { label: 'ブレインスリープ(BRAIN SLEEP)', fallbackRate: 13.8 },
    ダイソン: { label: 'ダイソン(Dyson)', fallbackRate: 6.3 },
    シャープ: { label: 'シャープ(SHARP)', fallbackRate: 8.7 },
    ビクセン: { label: 'ビクセン(Vixen)', fallbackRate: 10.8 },
    ミーゼ: { label: 'ミーゼ(mysé)', fallbackRate: 13.3 },
    ベネクス: { label: 'ベネクス(VENEX)', fallbackRate: 27.2 },
    アンカー: { label: 'アンカー(ANKER)', fallbackRate: 7.6 },
    サムソナイト: { label: 'サムソナイト(Samsonite)', fallbackRate: 1.3 },
    エフェクティム: { label: 'エフェクティム(EFFECTIM)', fallbackRate: 4.2 },
    ボリーナ: { label: 'ボリーナ(Bollina)', fallbackRate: 21.8 },
    シャーク: { label: 'シャーク(SHARK)', fallbackRate: 13.7 },
    ビサラ: { label: 'ビサラ(BISARA)', fallbackRate: 32.6 },
    ソノリプロ: { label: 'ソノリプロ(SonoRepro)', fallbackRate: 41.9 },
    ソーダストリーム: { label: 'ソーダストリーム(SodaStream)', fallbackRate: 12.5 },
    リアズ: { label: 'リアズ(REAZ)', fallbackRate: 30.0 },
    シロカ: { label: 'シロカ(siroca)', fallbackRate: 5.1 },
    バルミューダ: { label: 'バルミューダ(BALMUDA)', fallbackRate: 15.4 },
    マーシャル: { label: 'マーシャル(Marshall)', fallbackRate: 17.1 },
    ディズム: { label: 'ディズム(DISM)', fallbackRate: 3.1 },
    エーグローバル: { label: 'エーグローバル(A. GLOBAL)', fallbackRate: 3.3 },
    ルーヴルドー: { label: 'ルーヴルドー(LOUVREDO)', fallbackRate: 13.8 },
    エプソン: { label: 'エプソン(EPSON)', fallbackRate: 14.3 },
    エーテルアース: { label: 'エーテルアース(etell earth®)', fallbackRate: 57.1 },
    ガーミン: { label: 'ガーミン(garmin)', fallbackRate: 0.0 },
    ソニー: { label: 'ソニー(SONY)', fallbackRate: 4.5 },
    クワッズ: { label: 'クワッズ(QUADS)', fallbackRate: 15.8 },
    スイッチボット: { label: 'スイッチボット(SwitchBot)', fallbackRate: 5.3 },
    エコバックス: { label: 'エコバックス(ECOVACS)', fallbackRate: 10.5 },
    ラディアント: { label: 'ラディアント(radiant)', fallbackRate: 5.3 },
    アテックス: { label: 'アテックス ルルド(ATEX LOURDES)', fallbackRate: 22.2 },
    チョウチョウ: { label: 'チョウチョウ(CHOUCHOU)', fallbackRate: 18.2 },
    リコー: { label: 'リコー(ricoh)', fallbackRate: 9.1 },
    ボーズ: { label: 'ボーズ(BOSE)', fallbackRate: 0.0 },
    ソノス: { label: 'ソノス(SONOS)', fallbackRate: 10.0 },
};
//# sourceMappingURL=brands.js.map